var app = angular.module('leonardo');

var DocumentList = function (
  $scope,
  $q,
  $window,
  $filter,
  FolderService,
  $state,
  ngDialog,
  FilterService,
  AuthDataService,
  NoteService,
  TaskService,
  FolderRequirementsService,
  PermissionService,
  AccountUserService,
  NotificationService,
  $rootScope,
  AuthService,
  AnalyticsService
) {
  $scope.mode = $state.current.mode ? $state.current.mode : 'normal';
  $scope.list = $state.current.name === 'documents.list';
  $scope.currentFolder = null;
  $scope.folders = [];
  $scope.files = [];
  $scope.datas = {};
  $scope.loading = true;
  $scope.authDataService = AuthDataService;
  $scope.permissionService = PermissionService;
  $scope.AuthService = AuthService;

  $scope.breadCrumb = function (object) {
    var path = '';
    if (object.breadcrumb) {
      angular.forEach(object.breadcrumb, function (value) {
        path += value.name + ' > ';
      });
      path = path.slice(0, -3);
    }
    return path;
  };

  $scope.getSector = function () {
    if ((AuthDataService.isAdmin() || AuthDataService.isWhiteLabelAdmin()) && $scope.mode !== 'normal') {
      return FilterService.getFilter('sector');
    }
    return null;
  };

  $scope.showFile = function (file) {
    AnalyticsService.track('Document Opened', {
      ...AnalyticsService.getDocumentGroupProperties(file),
      context: 'Document Manager'
    });
    if (file.document_file) {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.document_file.signed_view_url || file.document_file.secure_share_url || file.document_file.file, '_blank');
    } else if (file.link) {
      $window.open(file.link, '_blank');
    } else {
      // Use signed_view_url for secure inline viewing, fallback to secure_share_url
      $window.open(file.signed_view_url || file.secure_share_url || file.file, '_blank');
    }
  };

  $scope.showNotes = function (file) {
    NoteService.get(file.note).then(function (note) {
      ngDialog.open({
        template: 'views/templates/dialog/folder-file/note-document.html',
        controller: 'DocumentNoteDialog',
        data: { note: note }
      });
    });
  };

  $scope.showFileAddDialog = function (requirement) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: [
          function () {
            if (requirement.document_folder) {
              return requirement.document_folder;
            }
            return null;
          }
        ]
      },
      data: {
        entity: null,
        action: 'create',
        status: 'missing',
        requirement: requirement
      }
    });
  };

  $scope.hideDynamicForm = function (folder) {
    return (
      folder &&
      folder.purpose === 7 &&
      !PermissionService.permissionAvailable(
        ['permission_add_dynamic_form', 'permission_edit_dynamic_form', 'permission_delete_dynamic_form'],
        folder
      )
    );
  };

  $scope.goToFolder = function (folder) {
    var params = folder ? { pk: folder.id ? folder.id : folder } : { pk: null };
    if (folder && folder.purpose === 7) {
      params = { pk: $state.params.pk ? folder.id : null };
      $state.go('documents.dynamic-forms-folder', params);
      return;
    }
    switch ($scope.mode) {
      case 'normal':
        $state.go('documents.list', params);
        break;
      case 'property':
        $state.go('documents.property', params);
        break;
      case 'portfolio':
        $state.go('documents.portfolio', params);
        break;
      case 'account':
        $state.go('documents.account', params);
        break;
    }
  };

  $scope.thereResults = function () {
    var requirements = $scope.currentFolder ? $scope.currentFolder.requirements : [];
    return $scope.folders.length > 0 || $scope.files.length > 0 || requirements.length > 0;
  };

  $scope.downloadFolder = function (folderObj) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/folder/warning.html',
        controller: 'DownloadWarningDialog',
        data: {
          folder: folderObj
        }
      })
      .then(function (folder) {
        if (folder) {
          folder.download().then(function () {
            NotificationService.notify('success', 'An email will be sent to you in a few moments.');
          });
        }
      }, function () {
        return;
      });
  };

  $scope.onEditFolder = function (folder) {
    ngDialog.open({
      template: 'views/templates/dialog/folder/add.html',
      controller: 'FolderAddDialog',
      data: {
        entity: folder,
        action: 'edit'
      }
    });
  };

  $scope.onDeleteFolder = function (folder) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: folder,
          type: 'folder',
          title: 'Delete Folder ' + folder.name
        }
      })
      .then(function () {
        $rootScope.$broadcast('folder:deleted');
      }, function () {
        return;
      });
  };

  $scope.onEditFile = function (file) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/upload.html',
      controller: 'FolderFileAdd',
      resolve: {
        folder: [
          function () {
            if ($state.params.pk) {
              return FolderService.get($state.params.pk);
            } else if (file.folder) {
              return FolderService.get(file.folder);
            }
            var defer = $q.defer();
            defer.resolve(null);
            return defer.promise;
          }
        ]
      },
      data: {
        entity: file,
        action: 'edit'
      }
    });
  };

  $scope.onUpdateFile = function (file) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/update.html',
      controller: 'FolderFileUpdate',
      data: {
        entity: file
      }
    });
  };

  $scope.onDeleteFile = function (file) {
    var alert_message = '';
    if (file.is_link) {
      alert_message = $filter('translate')(
        'This file is linked to another elements, ' + 'this action will remove all links. Do you maybe want to do an "Upload and Archive"?'
      );
    }
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/delete.html',
        controller: 'DeleteDialog',
        data: {
          object: file,
          alert_message: alert_message,
          type: 'file'
        }
      })
      .then(function () {
        $rootScope.$broadcast('folder-file:deleted');
      }, function () {
        return;
      });
  };

  $scope.onMoveFolder = function (folder) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/folder/selector.html',
        controller: 'FolderSelectorDialog',
        data: {
          excludeFolder: folder.id,
          sector: $scope.getSector(),
          rootDisabled: true
        }
      })
      .then(function (data) {
        var destiny = data ? data.destiny.id : null;
        if (data.action === 'move') {
          folder.moveTo({ to_folder: destiny }).then(function () {
            $rootScope.$broadcast('folder:updated');
          });
        } else {
          folder.copyTo({ to_folder: destiny }).then(function () {
            $rootScope.$broadcast('folder:updated');
          });
        }
      }, function () {
        return;
      });
  };

  $scope.onMoveFile = function (file) {
    ngDialog
      .openConfirm({
        template: 'views/templates/dialog/folder/selector.html',
        controller: 'FolderSelectorDialog',
        data: {
          excludeFolder: file.parent,
          rootDisabled: true,
          sector: $scope.getSector()
        }
      })
      .then(function (data) {
        var destiny = data ? data.destiny.id : data;
        if (data.action === 'move') {
          file.patch({ folder: destiny }).then(function () {
            $rootScope.$broadcast('folder-file:updated');
          });
        } else {
          file.copyTo({ to_folder: destiny }).then(function () {
            $rootScope.$broadcast('folder-file:updated');
          });
        }
      }, function () {
        return;
      });
  };

  $scope.onResolveFile = function (file) {
    TaskService.get(file.action_item).then(function (task) {
      ngDialog
        .openConfirm({
          template: 'views/templates/dialog/folder-file/resolve-document-file.html',
          controller: 'TaskResolveDocumentFileDialog',
          resolve: {
            folder: [
              function () {
                return null;
              }
            ]
          },
          data: {
            entity: null,
            task: task,
            name: file.name
          }
        })
        .then(function () {
          $rootScope.$broadcast('folder-file:updated');
        }, function () {
          return;
        });
    });
  };

  $scope.showSharePopup = function (file) {
    ngDialog.open({
      template: 'views/templates/dialog/folder-file/share-file.html',
      controller: 'FolderFileShareDialog',
      data: {
        file: file
      }
    });
  };

  $scope.showDismissPopup = function (file) {
    if (file.action_item) {
      TaskService.get(file.action_item).then(function (task) {
        ngDialog
          .openConfirm({
            template: 'views/templates/dialog/task/dismiss.html',
            controller: 'TaskDismissDialog',
            data: {
              task: task,
              file: file
            }
          })
          .then(function () {
            $rootScope.$broadcast('folder-file:updated');
          }, function () {
            return;
          });
      });
    } else {
      FolderRequirementsService.get(file.id).then(function (file_result) {
        ngDialog
          .openConfirm({
            template: 'views/templates/dialog/task/dismiss.html',
            controller: 'TaskDismissDialog',
            data: {
              file: file_result
            }
          })
          .then(function () {
            $rootScope.$broadcast('folder-file:updated');
            $rootScope.$broadcast('folder:updated');
          }, function () {
            return;
          });
      });
    }
  };

  $scope.hasRequirements = function (folder) {
    var has = false;
    if (folder.requirements && folder.requirements.length > 0) {
      angular.forEach(folder.requirements, function (requirement) {
        if (!requirement.filled) {
          has = true;
        }
      });
    } else {
      has = folder.missing_files_count > 0;
    }
    return has;
  };

  $scope.isExpired = function (file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.expiration && moment(new Date(file.expiration)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD')) {
        return true;
      }
    }
    return false;
  };

  $scope.isNoticed = function (file) {
    if (!file.archive && file.show_warning) {
      var today = moment(new Date());
      if (file.notice && moment(new Date(file.notice)).format('YYYY-MM-DD') <= today.format('YYYY-MM-DD')) {
        return true;
      }
    }
    return false;
  };

  $scope.canEdit = function (folder, action) {
    var can = false;
    var role_id = null;
    if (folder) {
      // for allowing account owner to move system created folder and file
      if (folder.type == FolderService.TYPE_SPECIAL && action !== 'move') {
        can = false;
      } else {
        var account_user = AccountUserService.getAccountUser(folder.account);
        if (account_user) {
          role_id = account_user.role ? account_user.role.id : account_user.role;
        }
        if(action == 'move' && folder.type == FolderService.TYPE_SPECIAL){
           can = PermissionService.isAccountOwner(account_user);
        }
        else {
          if (PermissionService.isOwner(account_user)) {
            can = true;
          } else if (folder.property) {
            let currentAccountProperty = $filter('filter')(FilterService.properties, {
              account: folder.account,
            });

            angular.forEach(currentAccountProperty, function (property) {
              if (property.id == folder.property) {
                if (folder.editable_by_roles && folder.editable_by_roles.length > 0) {
                  can = $scope.getCanEdit(folder.editable_by_roles, role_id);
                } else {
                  can = true;
                }
              }
            });
          } else if (folder.portfolio) {
            let currentAccountPortfolio = $filter('filter')(FilterService.portfolios, {
              account: folder.account,
            });

            angular.forEach(currentAccountPortfolio, function (portfolio) {
              if (portfolio.id == folder.portfolio) {
                if (folder.editable_by_roles && folder.editable_by_roles.length > 0) {
                  can = $scope.getCanEdit(folder.editable_by_roles, role_id);
                } else {
                  can = true;
                }
              }
            });
          } else {
            if (folder.editable_by_roles && folder.editable_by_roles.length > 0) {
              can = $scope.getCanEdit(folder.editable_by_roles, role_id);
            } else {
              can = true;
            }
          }
        }
      }
    }
    return can;
  };

  $scope.getCanEdit = function(folderRoles, role_id) {
    let can;
    let item1 = folderRoles[0]

    if(typeof item1 == 'object') {
      can = folderRoles.find(o => o.id === role_id);
      return !!can;
    } else if(typeof item1 == 'number') {
      can = folderRoles.includes(role_id);
      return !!can;
    } else return false;
  }

  $scope.$on('folder:loaded', function ($event, folder) {
    $scope.currentFolder = folder;
  });

  $scope.hasFolder = function(folder){
    let len = FolderService.selectedSourceFolders
        .filter(function(element) {
          return element.id == folder.id;
        });
    return len.length > 0
  }

  $scope.hasFile = function(file){
    let len = FolderService.selectedSourceFiles
        .filter(function(element) {
          return element.id == file.id;
        });
    return len.length > 0
  }


  $scope.selectFolder = function(folder){
    if($scope.hasFolder(folder)){
      FolderService.selectedSourceFolders =FolderService.selectedSourceFolders
      .filter(function(element) {
        return element.id !== folder.id;
      });
    }
    else {
      FolderService.selectedSourceFolders.push(folder);
    }

  }

  $scope.selectFile = function(file){
    if($scope.hasFolder(file)){
      FolderService.selectedSourceFiles = FolderService.selectedSourceFiles
      .filter(function(element) {
        return element.id !== file.id;
      });
    }
    else {
      FolderService.selectedSourceFiles.push(file);
    }

  }

  $scope.checkShowNext = function(){
    return FolderService.showNext;
  }

  $scope.$on("$stateChangeStart", function(e, toState, toParams, fromState, fromParams) {
    if(toState.name != 'documents.list'){
      FolderService.showNext = !FolderService.showNext;
      FolderService.selectedSourceFolders = [];
      FolderService.selectedSourceFiles = [];
      FolderService.isDefaultPropertyChanged = false;
    }
  });
};

app.controller('DocumentList', [
  '$scope',
  '$q',
  '$window',
  '$filter',
  'FolderService',
  '$state',
  'ngDialog',
  'FilterService',
  'AuthDataService',
  'NoteService',
  'TaskService',
  'FolderRequirementsService',
  'PermissionService',
  'AccountUserService',
  'NotificationService',
  '$rootScope',
  'AuthService',
  'AnalyticsService',
  DocumentList
]);
